import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgContactLedger({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 22 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 22.8c0 1.767-1.459 3.2-3.259 3.2H4.482c-1.8 0-3.26-1.433-3.26-3.2v-1.6h1.834c1.01 0 1.833-.808 1.833-1.8s-.822-1.8-1.833-1.8H1.223v-2.8h1.833c1.01 0 1.833-.808 1.833-1.8s-.822-1.8-1.833-1.8H1.223V8.4h1.833c1.01 0 1.833-.808 1.833-1.8 0-.993-.822-1.8-1.833-1.8H1.223V3.2c0-1.767 1.459-3.2 3.259-3.2h14.26C20.541 0 22 1.433 22 3.2v19.6ZM4.074 6.6c0-.552-.456-1-1.018-1H1.019A1.01 1.01 0 0 0 0 6.6c0 .552.456 1 1.019 1h2.037a1.01 1.01 0 0 0 1.018-1Zm0 6.4c0 .552-.456 1-1.018 1H1.019A1.01 1.01 0 0 1 0 13c0-.552.456-1 1.019-1h2.037a1.01 1.01 0 0 1 1.018 1Zm-1.018 5.4a1.01 1.01 0 0 1 1.018 1c0 .552-.456 1-1.018 1H1.019A1.01 1.01 0 0 1 0 19.4c0-.553.456-1 1.019-1h2.037Zm11.706-3.751a7.425 7.425 0 0 0 3.288.751c.22 0 .4.18.4.4v2.4a.4.4 0 0 1-.4.4c-5.955 0-10.8-4.845-10.8-10.8 0-.22.18-.4.4-.4h2.4c.22 0 .4.18.4.4 0 1.162.253 2.268.751 3.288a.4.4 0 0 1-.185.536l-1.3.63a10.061 10.061 0 0 0 3.881 3.882l.629-1.302a.403.403 0 0 1 .536-.185Z"
                fill="currentColor"
            />
        </svg>
    )
}
SvgContactLedger.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgContactLedger
